﻿import { Box, Grid, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUIButton, SCUILoading } from '../../../../atomic/atoms';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { CustomerCommand, OperatorCommand } from '../../../../services/command';
import TimeHelper from '../../../../utils/time';
import Swal from 'sweetalert2';
import { CAS } from './accountStatus.classes';
interface IProps {
    datas?: any;
    refresh?: any;
}

export const AccountStatus: FC<IProps> = ({ datas, refresh }) => {
    const { t } = useTranslation();
    const [status, setStatus] = React.useState(datas.customer.status);
    const [statusChangeHistroy, setStatusChangeHistory] = useState<any>([]);
    const [text, setText] = React.useState('');
    const [nameList, setNameList] = useState<any>([]);
    const handleChange = (event: any) => {
        setStatus(event.target.value);
    };
    const [refreshStatus, setRefreshStatus] = useState(false);
    const [pageSize, setPageSize] = React.useState(5);
    let array: any[];
    let uniqueSet: Set<any>;
    const refreshStatusList = () => {
        setRefreshStatus((prevLoading) => !prevLoading);
    };
    const columns: ExtendedGridColDef[] = [
        { field: 'date', headerName: t('general.date'), flex: 1 },
        {
            field: 'change',
            headerName: t('customerInformation.change'),
            flex: 1,
            renderCell: (params: any) => {
                let find_name = nameList.find(function (obj: any) {
                    return obj.operatorId === params.row.change;
                });
                return (
                    <>
                        {find_name ? (
                            find_name.firstName && find_name.lastName ? (
                                find_name.firstName + ' ' + find_name.lastName
                            ) : (
                                'OperatorId => ' + params.row.change
                            )
                        ) : (
                            <Grid sx={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                <SCUILoading />
                            </Grid>
                        )}
                    </>
                );
            },
        },
        { field: 'description', headerName: t('general.description'), flex: 1 },
    ];

    const GetCustomerStatusChangeHistoryList = async () => {
        CustomerCommand.GetCustomerStatusChangeHistoryList(datas.customer.customerId)
            .then((res: any) => {
                if (res.data) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            date: TimeHelper.formatDateHour(item.operationDate) || '-',
                            change: item.operatorId || '-',
                            description: item.statusChangeReason || '',
                        };
                    });
                    setStatusChangeHistory(parseData);
                    array = parseData.map((obje: any) => obje.change);
                    uniqueSet = new Set(array);
                    array = Array.from(uniqueSet);
                    GetUserNameByOperatorId(array);
                }
            })
            .finally(() => {});
    };
    const UpdateCustomerStatus = async () => {
        let params = {
            CustomerStatus: status,
            CustomerId: datas.customer.customerId,
            StatusChangeReason: text,
        };
        if (text && text.trim().length > 0) {
            CustomerCommand.UpdateCustomerStatus(params).then(() => {
                Swal.fire(t('general.added'), ' ', 'success');
                refreshStatusList();
                setText('');
            });
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };
    const GetUserNameByOperatorId = async (array: any) => {
        if (array?.length > 0) {
            OperatorCommand.GetOperatorsByOperatorId({ operatorIds: array }).then((res: any) => {
                if (res) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            operatorId: item.operatorId,
                            firstName: item.firstName,
                            lastName: item.lastName,
                        };
                    });
                    setNameList(parseData);
                }
            });
        }
    };
    useEffect(() => {
        GetCustomerStatusChangeHistoryList();
        // setTimeout(() => {
        //   GetUserNameByOperatorId();
        // }, 1000);
    }, [refreshStatus]);
    return (
        <Grid container className={CAS.page}>
            <Grid
                className={CAS.formColumn}
                container
                sx={{ padding: '8px', marginTop: '2rem' }}
                size={{
                    xl: 3,
                    lg: 3,
                    md: 12,
                    xs: 12,
                }}
            >
                <Grid
                    sx={{ marginBottom: '8px' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <FormControl className={CAS.fieldAccountStatus} fullWidth>
                        <InputLabel id="select-label">{t('customerInformation.accountStatus')}</InputLabel>
                        <Select
                            className={CAS.inputSelectStatus}
                            labelId="select-label"
                            value={status}
                            onChange={handleChange}
                            sx={{ marginTop: '0.4rem' }}
                        >
                            <MenuItem value={1}>{t('general.active')}</MenuItem>
                            <MenuItem value={2}>{t('general.passive')}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={CAS.inputTextfieldReason}
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={6}
                        placeholder={t('customerInformation.reasonChange')}
                        value={text}
                        onChange={(event: any) => {
                            setText(event.target.value);
                        }}
                    />
                </Grid>
                <Grid
                    className={CAS.formActions}
                    display={'flex'}
                    justifyContent={'flex-end'}
                    sx={{ marginTop: '1rem' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <SCUIButton
                        className={CAS.inputButtonSend}
                        text={t('general.send')}
                        type="primary"
                        style={{ height: '32px' }}
                        sizeType="default"
                        size="s"
                        onClick={() => {
                            UpdateCustomerStatus();
                            refresh();
                        }}
                    />
                </Grid>
            </Grid>
            <Grid
                className={CAS.historyColumn}
                container
                sx={{ padding: '8px' }}
                size={{
                    xl: 9,
                    lg: 9,
                    md: 12,
                    xs: 12,
                }}
            >
                <Grid
                    className={CAS.historyGridInner}
                    sx={{ marginLeft: '1rem' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Box className={CAS.datagrid}>
                        <SCUICustomDataGrid
                            randomId
                            rows={statusChangeHistroy}
                            columns={columns}
                            pageSize={pageSize}
                            onPageSizeChange={(i: number) => {
                                setPageSize(i);
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};

